import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=1eb387d0&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"
import style0 from "./phone.vue?vue&type=style&index=0&id=1eb387d0&prod&lang=scss&scoped=true"
import style1 from "./phone.vue?vue&type=style&index=1&id=1eb387d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb387d0",
  null
  
)

export default component.exports